package com.essntl.uikit.components.utils

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.uikit.components.utils.EsConstants.LargeSectionHorizontalPadding
import com.essntl.uikit.components.utils.EsConstants.LargeSectionVerticalPadding
import com.essntl.uikit.theme.esColorScheme

object EsModifiers {

    val LargeSectionModifier
        @Composable
        get() = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = LargeSectionVerticalPadding,
                horizontal = LargeSectionHorizontalPadding,
            )

}